<!-- Add to Monitoring Zone Modal-->
<template>
    <b-modal
      :visible="visible"
      @change="change"
      @show="fillModal"
      :hide-footer="footerHide"
      ok-only
      ref="modal"
      id="modal-add-to-zone"
      :title="$t('add_to_monitoring_zone.title')"
      :ok-title="zonaLampada == null ? $t('add_to_monitoring_zone.button_add_to_zone') : $t('add_to_monitoring_zone.button_cancel')"
      :cancel-title="$t('add_to_monitoring_zone.button_cancel')"
      @ok="handleOk"
    >
     
    <b-row>
      <b-col cols="12">
        <h6 class="ml-2">{{$t("add_to_monitoring_zone.lamp_selected")}}</h6>
        <b-row class="pt-2 ml-2 mr-2" style="border: 1px solid #009DE0;"> 
          <b-col cols="6" class="subtitle"> 
              <div v-if="this.lamp">
                <h6 v-if="!this.lamp.product_desc.includes('Unknown')">{{this.lamp.product_desc}}</h6>
                <h6 v-else>--</h6>
                <h6><b> ID: {{this.lamp.id}}</b></h6>
                <h6 v-if="!this.lamp.product_code.includes('NT')">cod: {{this.lamp.product_code}}</h6>
                <h6 v-else>cod: --</h6>
              </div>
          </b-col>
          <b-col v-if="this.lamp" cols="3" class="text-right" >
              <img v-if="this.lamp.product_image" :src="this.pathDeviceImages + this.lamp.product_image" style="width:100%; height: auto" />
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="zonaLampada == null" class="ml-2 mt-4 mb-4">  
            <h6>{{$t("add_to_monitoring_zone.label_select_zone")}}</h6>
              <b-form-select v-model="zoneSelected" class='mt-2'>
              <option :value="null" disabled>{{$t("add_to_monitoring_zone.placeholder")}}</option>
              <option v-for="(selectOption, indexOpt) in this.zones" 
                :key="indexOpt"
                :value="selectOption"
              >
              {{ selectOption.zoneName }}
              </option>
            </b-form-select>
          </b-col>
          <b-col v-else class="ml-2 mt-4 mb-4">  
            <h6>{{$t("add_to_monitoring_zone.lamp_already_in_zone")}}</h6>
             <div class="mt-2" style="color: #009de0"><b>{{zonaLampada}}</b></div> 
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AddToMonitoringZone",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    lamp: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    alerts:{
      default: []
    }
  },
  data() {
    return {
      lampSerial: "",
      lampDesc:"",
      footerHide: false,
      spinner: false,
      zones: null,
      zoneSelected:null,
      timerTimeout: 5,
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES
    };
  },
  computed: { 
    ...mapState(['loading','commandResponse']),

    //output: se la lampada è già presente in una zona, ritorna la zona in cui è presente, oppure null
    zonaLampada() {
      let zonaTrovata = null;
      let trovato = false;
      console.log("zonaLampada, lamp: ", this.lamp);
      if((this.zones!=null) && (this.lamp != null))
      {
        this.zones.some((zone) => {
          if (zone.lamps.length == 0) {
            return false;
          } 
          else {
            console.log("zonaLampada, zone.lamps: ", zone.lamps);
            zone.lamps.some((lampInZone) => {
              if (lampInZone.id == this.lamp.id && lampInZone.cu_id == this.lamp.cu_id) {
                zonaTrovata = zone.zoneName;
                trovato = true;
              }
              return trovato;
            });
            return trovato;
          }
        })
      }
      console.log("Zona trovata: ", zonaTrovata);
      return zonaTrovata;
    }

  },
  watch: {
    loading(val,oldval) {
      if (val!=oldval && this.zones==null)
      {
        this.zones=this.$store.state.monitoringZones;
        console.log("Loaded zones ", this.zones);
      }
    },

    commandResponse(val) {
      console.log("cambiata commandResponse ->", val);
      if(val.command == "updateMonitoringZone") {
        //aggiorno le zone di monitoraggio dopo le aggiunte fatte
        this.$store.dispatch("loadPlantMonitoringZones", this.$store.state.currentPlant.id);
        //segnalo che tutto è andato a buon fine
        var alert = {
            timeLeft: 5,
            state: "success",
            msg: this.$t("add_to_monitoring_zone.lamps_added"),
            countDownChanged: function (cd)
            {
                //timeLeft = cd;
                console.log("countdownchanged:" + cd)
            }
        }
        this.alerts.push(alert);
        //segnalo che ho eseguito l'aggiornamento
        this.$emit("updated-zone");
      }        
    }
  },
  methods: {


    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    handleRemove(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();  
    },
    fillModal(){
      this.zoneSelected = null;
      if (this.zones==null)
      {
        this.$store.dispatch("loadPlantMonitoringZones", this.$store.state.currentPlant.id);
      }
      else
      {
        console.log("Present monitoring zone ", this.zones);
      }
    },
    handleOk() {
      // get lamp to monitor and push in array lamps zone
      if(this.zoneSelected != null)
      {
        var lampToMonitor={};
        var updatedZone={};
        
        lampToMonitor.id=this.lamp.id;
        lampToMonitor.cu_id=this.lamp.cu_id;
        
        updatedZone=this.zoneSelected;
        
        // var lampPresent = updatedZone.lamps.filter(function(elem){
        //   if(elem.id == lampToMonitor.id && elem.cu_id == lampToMonitor.cu_id) 
        //   { 
        //     return elem;
        //   }
        // });

        // if(lampPresent.length==0)
        // {
        updatedZone.lamps.push(lampToMonitor);  
        console.log("Updated zone: ", updatedZone);
        this.$store.dispatch("updateMonitoringZone", updatedZone);
        // }
      }  
    }

  }
};
</script>
